import { gql } from '@grandvisionhq/graphql';

const calendarAvailability = gql`
  fragment CalendarAvailability on Availability {
    perDay
    percentageAvailable
    slotsAvailable
    storeCode
  }
`;
const GET_CALENDAR_AVAILABILITY = gql`
  query GetCalendarAvailability(
    $appointmentTypeIds: [ID!]!
    $endDate: String!
    $endTime: String
    $startDate: String!
    $startTime: String
    $storeCodes: [String!]!
  ) {
    availabilityByStoreCodes(
      appointmentTypeIds: $appointmentTypeIds
      endDate: $endDate
      endTime: $endTime
      startDate: $startDate
      startTime: $startTime
      storeCodes: $storeCodes
    ) {
      ...CalendarAvailability
    }
  }
  ${calendarAvailability}
`;

export { GET_CALENDAR_AVAILABILITY };
//# sourceMappingURL=get-calendar-availability.js.map
